import axios from 'axios'
import router from '../router'

const service = axios.create({
    // baseURL: process.env.baseUrl, // api的base_url
    // baseURL:"http://192.168.66.196:8001/api",
    baseURL:'http://biomed3d.newacademic.net/api',
    timeout: 50000 // 请求超时时间
})
// 请求拦截器 
service.interceptors.request.use((config) => { 
    // console.log(config);
    // 动态设置请求头
      if(window.localStorage.getItem("token")){
          config.headers.common = {
              token: window.localStorage.getItem("token"),
          }
      }
      
    //   if (config.method === 'post') {
    //       if(config.data.type === "application/x-www-form-urlencoded"){
    //           config.data = stringify(config.data)
    //       }else{
    //           config.data = {
    //               ...config.data,
    //               // t: Date.parse(new Date())
    //           }
    //       }
    //   } else if (config.method === 'get') {
    //       config.params = {
    //       ...config.params,
    //       t: Date.parse(new Date())
    //       }
    //   }
      return config
  }, (err) => {
      return Promise.reject(err)
  })
  
  // 响应拦截器
  service.interceptors.response.use((res) => {
    console.log(res);
    
      if (res.data.code == 200) {
          // 请求成功，正常返回
          return res.data
      }else if (res.data.token_code == 401) {
          // token失效，清除localstorage
          // storage.remove();
          // 跳转登录页
          router.push({
              name: "login",
          });
      }else if(res.data.token_code == 402){
            router.push({
                name: "login",
            });
          // 请求失败
          // Message.error(res.data.msg);
      }else{
        return res.data
      }
      return res.data
  }, (err) => {
    // 接口请求失败（404或500的情况）
  //   Message.error('请求超时');
    return Promise.reject(err)
  })
  
//   router.beforeEach((to, from, next) => {
//     if (to.path !== '/login' && window.localStorage.getItem("token")) {
//       // 用户未登录跳转到登录页面
//       return next('/login')
//     } else {
//         return next()
//     }
//   })
  export default service